module.exports = __webpack_public_path__ + "media/wsd-video.fd1e5f27.mp4";